export function buildMriFromAADObjectId(aadObjectId?: string): string | undefined {
    // MRI format doc: https://skype.visualstudio.com/SKYPECENTRAL/_wiki/wikis/SKYPECENTRAL.wiki/3055/Cloud-Specific-MRIs
    // TODO: getVariantEnvironment() is deprecated.  When we roll out to GccHigh and/or DoD we should detect that and update the id.
    return aadObjectId ? `8:orgid:${aadObjectId}` : undefined;
}
